import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Helmet } from 'react-helmet'
import { commonActions } from 'srcReact/components'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import ContactSuccess from './components/ContactSuccess'
import ContactForm from './components/ContactForm'
import { isUserAuthorized } from 'srcReact/helpers/userHelper'
import styles from './styles.module.scss'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import { supportActions } from '../actions'

function ContactUs(props) {
  const { t } = useTranslation()
  const urlParams = new URLSearchParams(window.location.search)
  const isAuthorized = isUserAuthorized()
  const authFields = ['subject', 'message']
  const nonAuthFields = [
    'firstname',
    'lastname',
    'email',
    'country',
    'occupation',
    'organization',
    'subject',
    'message'
  ]
  const {
    support: { contact },
    alert
  } = useSelector((state) => state)
  const dispatch = useDispatch()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  function mapContact(contact) {
    const filterFields = isAuthorized ? authFields : nonAuthFields
    let newContact = {}
    for (const key in contact) {
      if (filterFields.includes(key)) {
        newContact[key] = contact[key].value
      }
    }
    return newContact
  }

  function handleSubmit(contact, fileIds) {
    const updatedContact = mapContact(contact)
    if (fileIds?.length > 0) {
      updatedContact.file_ids = fileIds
    }
    if (isAuthorized) {
      updatedContact.id_organization = getCurrentOrgId()
    }
    dispatch(supportActions.postTicket(updatedContact))
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>{t('meta.contact.title')}</title>
        <meta name='description' content={t('meta.contact.description')} />
      </Helmet>
      <PageContainer
        pageTitle={t('meta.contact.title')}
        pageKeywords={t('meta.contact.keywords')}
        pageDescription={t('meta.contact.description')}>
        <div className={styles.contactusWrapper}>
          <div className={styles.contactus}>
            <h1 className={styles.title}>{isAuthorized ? t('contact.headingAuth') : t('contact.heading')}</h1>
            <h2 className={styles.subtitle}>{isAuthorized ? t('contact.subheadingAuth') : t('contact.subheading')}</h2>
            {contact && contact.success ? (
              <div className={styles.content}>
                <ContactSuccess title={t('contact.success-title')} isAuthorized={isAuthorized} />
              </div>
            ) : (
              <div className={styles.content}>
                <ContactForm
                  isAuthorized={isAuthorized}
                  title={isAuthorized ? t('contact.titleAuth') : t('contact.title')}
                  handleSubmit={handleSubmit}
                  error={alert && alert.message}
                  loadingMessage={contact && contact.loading}
                  isCloseMyAccount={urlParams.get('close') == 1}
                  authFields={authFields}
                  nonAuthFields={nonAuthFields}
                />
              </div>
            )}
          </div>
        </div>
      </PageContainer>
    </React.Fragment>
  )
}

export default ContactUs
